import React from "react";
import { motion } from "framer-motion";
import { FlameIcon } from "lucide-react";
type ScarcityBarProps = {
  dark?: boolean;
};
export function ScarcityBar({
  dark = false
}: ScarcityBarProps) {
  return <div className={`w-full rounded-2xl border p-4 ${dark ? "border-white/15 bg-white/5" : "border-refer/20 bg-red-50"}`} data-id="element-50" data-mp="2l5plpx8ens8c">
      <div className="mb-2.5 flex items-center justify-between gap-3" data-id="element-51" data-mp="2q2g5ovnbz7z1">
        <p className={`flex items-center gap-1.5 text-sm font-bold ${dark ? "text-white" : "text-ink"}`} data-id="element-52" data-mp="2b6gw1gkkozrs">
          <FlameIcon className="h-4 w-4 shrink-0 text-refer" aria-hidden="true" data-id="element-53" data-mp="2g6w884t4c186" />
          Only <span className="text-refer" data-id="element-54" data-mp="226tw6z7hs20u">7 spots</span> left at the promo price
        </p>
        <span className={`shrink-0 text-sm font-black ${dark ? "text-white" : "text-refer"}`} data-id="element-55" data-mp="274mznkheuhxf">93%</span>
      </div>
      <div className={`h-3.5 w-full overflow-hidden rounded-full ${dark ? "bg-white/15" : "bg-red-100"}`} data-id="element-56" data-mp="efdhxx4itjd">
        <motion.div className="h-full rounded-full bg-refer" initial={{
        width: "0%"
      }} whileInView={{
        width: "93%"
      }} viewport={{
        once: true
      }} transition={{
        duration: 1.1,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-57" data-mp="5cqquimmnm6c" />
      </div>
      <p className={`mt-2 text-xs font-medium ${dark ? "text-white/70" : "text-muted"}`} data-id="element-58" data-mp="3dd7py7mugw9r">
        93% claimed · The price goes up when the bar fills
      </p>
    </div>;
}